export const tl = (langMap: any, key: string, lang: string)=> {
    const item = langMap[key];
    if (!item) {
        return key
    }
    if (lang === 'sv') return item[1]
    return item[0]
}